import React from "react";
import "./style.css";

export const Footer = () => {
  return <div id="footer-spacer"></div>;
};
